import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import React from 'react';
import { Provider } from 'react-redux';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import ElectronicSignatureSetup from './ElectronicSignatureSetup';

loadDOMComponent({
	selector: 'react-electronic-signature-setup',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<ElectronicSignatureSetup />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
